import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 500px)
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-173">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 p-4 z-50 md:hidden shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]" data-id="element-174">
          <div className="flex items-center justify-between gap-4" data-id="element-175">
            <div className="flex flex-col" data-id="element-176">
              <span className="text-xs text-gray-500 uppercase font-bold" data-id="element-177">
                Oferta Limitada
              </span>
              <span className="text-lg font-bold text-[#2B0A3D]" data-id="element-178">
                $7.97 USD
              </span>
            </div>
            <Button scrollTo="oferta" variant="primary" size="md" className="flex-1" data-id="element-179">
              Ver oferta
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}